import { createFileRoute, Outlet } from '@tanstack/react-router';
import { RunsPage } from '@/pages/admin/system-monitor/runs-page';

/**
 * La lista delle esecuzioni resta montata e il dettaglio del job si apre
 * sopra di lei sull'`Outlet` (`$id`), come nella webapp: chiudere il
 * pannello torna alla lista senza perdere lo scorrimento.
 */
export const Route = createFileRoute(
  '/admin/_layout/system-monitor/_layout/runs/_layout'
)({
  component: RunsLayout,
});

function RunsLayout() {
  return (
    <>
      <RunsPage />
      <Outlet />
    </>
  );
}
